import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LeadManagementComponent } from './lead-management.component';
import { LeadListComponent } from './lead-list/lead-list.component';
import { LeadDetailsComponent } from './lead-details/lead-details.component';
import { OutgoingLeadListComponent } from './outgoing-lead-list/outgoing-lead-list.component';
import { HomeSecurityLeadListComponent } from './home-security-lead-list/home-security-lead-list.component';
import { CallrailLeadListComponent } from './callrail-lead-list/callrail-lead-list.component';
import { CallrailLeadDetailsComponent } from './callrail-lead-details/callrail-lead-details.component';

const routes: Routes = [
  {
    path: '',
    component : LeadManagementComponent,
    children: [
      {
        path: 'lead-list',
        component : LeadListComponent
      },
      {
        path: 'lead-details/:id',
        component: LeadDetailsComponent
      },
      {
        path : 'callrail-lead-details/:id',
        component: CallrailLeadDetailsComponent
      },
      {
        path: 'outgoing-lead-list',
        component : OutgoingLeadListComponent
      },
      {
        path: 'home-security-lead-list',
        component : HomeSecurityLeadListComponent
      },
      {
        path: 'call-rail-lead-list',
        component : CallrailLeadListComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LeadManagementRoutingModule { }
